var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpansionExistingCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 147,
    viewBox: "0 0 180 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1866_5329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.3115 83.6235C88.4239 83.6235 107.16 64.9037 107.16 41.8118C107.16 18.7198 88.4239 0 65.3115 0C42.1991 0 23.4628 18.7198 23.4628 41.8118C23.4628 64.9037 42.1991 83.6235 65.3115 83.6235Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.892 156.713V163.474C128.892 165.973 126.971 168 124.61 168H4.28177C1.91313 168 0 165.973 0 163.474V109.689C0 98.0958 8.87826 88.7041 19.8353 88.7041H53.4352C53.8493 88.7041 54.222 88.9606 54.3959 89.3661L64.0526 109.929C64.2183 110.268 64.6738 110.268 64.8311 109.929L74.4962 89.3661C74.6618 88.9606 75.0428 88.7041 75.4569 88.7041H97.6857C94.0168 95.3569 91.9214 103.011 91.9214 111.153C91.9214 133.569 107.773 152.278 128.892 156.713Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.375 152.394C161.291 152.394 179.859 133.842 179.859 110.955C179.859 88.0587 161.291 69.507 138.375 69.507C123.749 69.507 110.887 77.07 103.508 88.5055C99.3255 94.968 96.8989 102.68 96.8989 110.955C96.8989 130.532 110.481 146.941 128.751 151.269C131.84 152.005 135.062 152.394 138.375 152.394ZM153.288 88.6819C156.296 88.6819 158.822 90.7491 159.521 93.5384L159.72 93.737V112.68C159.72 116.224 156.842 119.099 153.295 119.099C149.748 119.099 146.87 116.224 146.87 112.68V110.594L127.058 130.388C124.549 132.896 120.486 132.896 117.976 130.388C115.467 127.881 115.467 123.822 117.976 121.315L137.788 101.52H135.701C132.154 101.52 129.276 98.6451 129.276 95.1011C129.276 91.5572 132.154 88.6819 135.701 88.6819H153.288Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1866_5329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 168,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpansionExistingCustomer);
export default __webpack_public_path__ + "static/media/ExpansionExistingCustomer.31c5c7dd5fc588ca2b69f49b9a7c68ae.svg";
export { ForwardRef as ReactComponent };